<template>
    <font-awesome-icon :icon="['fal', icon ]" />
</template>

<script>
    export default {
        name: "icon",
        props: {
            icon: {
                default: "question",
                type: String
            }
        }
    }
</script>